/**
 * @title dsr-helper.js: Sub-module of CCPA feature
 * @description This module provides validation and submission of the cash card form
 * @dependency
 */
 define(['addressForm'], function(addressForm) {
	let DSRHelper = {
			
		/** The init method */
		init: function() {
			DSRHelper.populateState();
			DSRHelper.manageDisplay();
			DSRHelper.yearBirth();
			if(addressForm.isUS()) {
				$('#DSRForm').find('[name=postal]').unmask().mask('00000-0000');
			}
			$('#DSRForm').find('[name=memberId]').unmask().mask('000000000000');
			$('#DSRForm').find('[name=birthYearCCPA]').unmask().mask('0000');
			$('#DSRForm').find('.critical-notification').addClass('ccpa-critical-error').removeClass('critical-notification');

			DSRHelper.handleShowTopNotification(null);
		},

		removeError: function() {
			$('.ccpa-consumer-rights-main').find('.ccpa-request-check-box').removeClass('ccpa-critical-error');
			$('.ccpa-consumer-rights-main').find('.ccpa-request-check-box-content').removeClass('ccpa-request-check-box-content-error');
			$('#checkbox-error-msg-div').addClass('hidden');

			COSTCO.util.ariaSetElementAsValid($('#c1'));
			window.digitalDataEvents = [];
		},

		focusAndScrollToElement: function(alertElement, focusElement, scrollElement) {
			if (alertElement && (typeof alertElement === 'object')) {
				alertElement.removeAttr('role');
				alertElement.attr('role', 'alert');
			}

			if (focusElement && (typeof focusElement === 'object')) {
				focusElement.attr('tabindex', 0);
				focusElement.focus();
			}
			
			if (scrollElement && (typeof scrollElement === 'object')) {
				$('body, html').animate({
					scrollTop: scrollElement.offset().top - 30,
				}, 800);
			}
		},

		handleShowTopNotification: function(optionalFocusElement) {
			let errorMainDiv = $('#errorMessageContainerDiv');
			if ((errorMainDiv.length === 1) && !errorMainDiv.hasClass('hide')) {
				let errorElement = $('#errorMessageDiv');
				let focusElement = (optionalFocusElement !== null && optionalFocusElement !== undefined) ? optionalFocusElement : errorElement;
				DSRHelper.focusAndScrollToElement(errorElement, focusElement, errorElement);
			}
		},

		yearBirth: function() {
			$('#DSRForm').find('[name=birthYearCCPA]').on('input', function(event) {
				if($('#DSRForm').find('[name=birthYearCCPA]').hasClass('error')) {
					COSTCO.util.showHtmlElementByFlag($('.ccpa-consumer-page').find('.ccpa-year-birth-desc'), false);

					if($('#DSRForm').find('[name=birthYearCCPA]').val() === '') {
						$(element).attr('placeholder', 'YYYY');
					}
				}
			});
		},

		/** Method to populate city and state based on the zipcode */
		populateState: function() {
			var stateProvList = countries;
			var stateOptions = COSTCO.CAddressForm.getStateOptions(stateProvList, undefined, undefined);
			var countryOptions = COSTCO.CAddressForm.getCountryOptions(undefined);
			$('#DSRForm').find('.stateprov-select').empty().append(stateOptions);
			$('#DSRForm').find('[name=postal]').on('input', function(event){
				var value = $(this).val();
				let region = COSTCO.util.isUsOrCaZipCode();
				if($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4){
					COSTCO.CAddress.bingCityState(this,'[name=city]','[name=state]');
					COSTCO.util.showHtmlElementByFlag($('.ccpa-state-city-address'), true);
				}
				if($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length){
					if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
						COSTCO.CAddress.geocodeApiCityState(this,'[name=city]','[name=state]');
					}
					if (!region) {
						if ((value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim())) || (value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())))
						COSTCO.CAddress.geocodeApiCityState(this,'[name=city]', '[name=state]');
					}
					COSTCO.util.showHtmlElementByFlag($('.ccpa-state-city-address'), true);
				}
			});
			var state = $('#DSRForm').find('[name=savedState]').val();
			if(state != undefined && state != "" ){
				$('#DSRForm').find('[name=state]').val(state);
			}
		},

		fetchstateList: function() {
			if($('#DSRLanding').find('.stateprov-state').val()==null){
				var stateProvList = countries;
				var stateOptions = COSTCO.CAddressForm.getStateOptions(stateProvList,undefined,undefined);
				$('#DSRLanding').find('.stateprov-state').append(stateOptions.replace("Select", ""));
			}
		},

		/** selects the input radio buttons inside the given element
		 * used for all the radio buttons/selection-boxes combined elements */
		selectRadioBox: function(element) {
			$(element).find('input').prop('checked', true);
		},

		/** changes the has account radio buttons to reuired according to the on behalf selection */
		toggleHasAccountAriaRequired: function(element, isRequired) {
			let form = $('#DSRLanding');
			form.find('#hasAccountSelectionSet').attr('aria-required', isRequired);
			form.find(':input[name="ccpaHasAccount"]').attr('aria-required', isRequired);

			DSRHelper.selectRadioBox(element);
		},

		/** Method to toggle addressline2 */
		toggleAddress: function () {
			COSTCO.util.showHtmlElementByFlag($('.ccpa-address-link'), false);
			COSTCO.util.showHtmlElementByFlag($('.ccpa-address-line2'), true);
		},
		validateRequiredData: function() {
			let isAvailable=false;
			let fName=$('#fName').val();
			let lName=$('#lName').val();
			let email=$('#email').val();
			let streetAddress=$('#streetAddress').val();
			let city=$('#city').val();
			let state=$('#state').val();
		    let postal=$('#postal').val();
		    if( !(fName && fName != '""' && fName != '')|| !(lName && lName != '""' && lName != '')||
		    		!(email && email != '""' && email != '')|| !(streetAddress && streetAddress != '""' && streetAddress != '')|| 
		    		!(city && city != '""' && city != '')|| !(state && state != '""' && state != '' && state !="NO_STATE_TYPE_SELECTED")||
		    		!(postal && postal != '""' && postal != '')){
		    	isAvailable=true;
		    }
		    return isAvailable;
		},
		/** Method to manage verified/non-verified/no-online account of DSR Page */
		manageDisplay : function(){
			let isverified = $('#DSRForm').find('[name=isVerified]').val();
			let isNonMember = $('#DSRForm').find('[name=isNonMember]').val();
			let isEmailOtpValid = $('#DSRForm').find('[name=isEmailOtpValid]').val();
			let memberId = $('#memberId').val();
			if(isverified === 'true'){ 
				if(DSRHelper.validateRequiredData()){
				DSRHelper.manageEmptyCRMResponse();
				 }else{
					COSTCO.util.showHtmlElementByFlag($('.consumer-data-main'), true);
					COSTCO.util.showHtmlElementByFlag($('.ccpa-consumer-field-box'), false);
					COSTCO.util.showHtmlElementByFlag($('.ccpa-non-verified-address'), false);
					COSTCO.util.showHtmlElementByFlag($('.ccpa-email-verified-container'), false);
				 }
			}
			else if(isEmailOtpValid === 'true'){
				COSTCO.util.showHtmlElementByFlag($('.consumer-data-main'), true);
				COSTCO.util.showHtmlElementByFlag($('.ccpa-email-verified-container'), true);
				COSTCO.util.showHtmlElementByFlag($('.ccpa-consumer-field-box'), false);
				COSTCO.util.showHtmlElementByFlag($('.ccpa-user-address'), true);
				COSTCO.util.showHtmlElementByFlag($('.ccpa-non-verified-address'), false);
				if(memberId === '') {
					COSTCO.util.showHtmlElementByFlag($('.ccpa-membership-number-container'), false);
				}
				$('.ccpa-email-verified').attr('role', 'alert');
			 }
			else if(isverified ==='false' && isNonMember !== 'true'){
				COSTCO.util.showHtmlElementByFlag($('.ccpa-consumer-field-box'), false);
				COSTCO.util.showHtmlElementByFlag($('.consumer-data-main'), true);
				COSTCO.util.showHtmlElementByFlag($('.ccpa-non-verified-address'), true);
				COSTCO.util.showHtmlElementByFlag($('.ccpa-user-address'), false);
				COSTCO.util.showHtmlElementByFlag($('.ccpa-non-mbr-address'), true);
				COSTCO.util.showHtmlElementByFlag($('.ccpa-email-verified-container'), false);
			}
			else{
				COSTCO.util.showHtmlElementByFlag($('.consumer-data-main'), false);
				COSTCO.util.showHtmlElementByFlag($('.ccpa-consumer-field-box'), true);
				COSTCO.util.showHtmlElementByFlag($('.ccpa-email-verified-container'), false);
				
			}
		},
		manageEmptyCRMResponse : function(){
			COSTCO.util.showHtmlElementByFlag($('.consumer-data-main'), false);
			COSTCO.util.showHtmlElementByFlag($('.ccpa-consumer-field-box'), true);
			COSTCO.util.showHtmlElementByFlag($('.ccpa-state-city-address'), true);
			DSRHelper.clearError();
			DSRHelper.emailconfirmationDisplay();
			var editMessage = '<span class="ccpa-body-copy">'+messages.CCPA_EDIT_INFO_YEAR_OF_BIRTH+'</span>';
			$('.ccpa-consumer-page').find('.edit-description').empty().append(editMessage);
		},
		
		/** Method to manage DSRForm edit */
		manageDSREditLink : function(){
			COSTCO.util.showHtmlElementByFlag($('.consumer-data-main'), false);
			COSTCO.util.showHtmlElementByFlag($('.ccpa-consumer-field-box'), true);
			var state = $('#DSRForm').find('[name=savedState]').val();
			if(state != undefined && state != ""  ){
				COSTCO.util.showHtmlElementByFlag($('.ccpa-state-city-address'), true);
			}
			DSRHelper.clearError();
			DSRHelper.emailconfirmationDisplay();
			var editMessage = '<span class="ccpa-body-copy">'+messages.CCPA_EDIT_INFO_YEAR_OF_BIRTH+'</span>';
			$('.ccpa-consumer-page').find('.edit-description').empty().append(editMessage);
			$('#DSRForm').find('[name=dsrContinueBtn]').attr('onclick', 'COSTCO.DSRHelper.continueValidationOnEditedForm();');
		},
		emailconfirmationDisplay : function(){
			$('.ccpa-confirmation-email').addClass('ccpa-confirmation-email-exp');
			$('#DSRForm').find('[name=email]').on('input', function(event){
				// Email Verification to be completed on edited email address
				$('#DSRForm').find('[name=isEmailOtpValid]').val(false);
				$('#DSRForm').find('[name=dsrContinueBtn]').attr('onclick', 'COSTCO.DSRHelper.validateReCaptcha(grecaptcha);');
				var value = $(this).val();
				if(value != null && value != ""){
					$('.ccpa-confirmation-email-exp').addClass('ccpa-confirmation-email-space');
					DSRHelper.confirmEmailDetails();
					$('#DSRForm').find('[name=confirmEmail]').removeAttr('tabindex');

				}
			});
			$('#DSRForm').find('[name=confirmEmail]').attr('tabindex', '-1');
		},
		confirmEmailDetails : function(){
			$('#DSRForm').find('[name=confirmEmail]').focus(function(){
				$('.ccpa-confirmation-email').removeClass('ccpa-confirmation-email-exp');
				$('.ccpa-confirmation-email-exp').removeClass('ccpa-confirmation-email-space');
			});
		},	
		/** Method to clear errors in DSRView */
		clearError : function(){
			COSTCO.util.showHtmlElementByFlag($('.ccpa-consumer-page').find('.ccpa-critical-error'), false);
			$('.ccpa-consumer-page').find('.ccpa-error-msg').empty();
		},
		getIsStateSelected: function() {
			let selectedState = $('[name=state] option:selected').val();
			if (selectedState== undefined) {
				return false;
			}
			return (selectedState != "NO_STATE_TYPE_SELECTED");
		},

		/** shows or hides errorMessageDiv with error classes according to the parameter */
		showHideErrorMessage: function(isShow) {
			let msgElement = $('#errorMessageDiv');

			if (isShow) {
				msgElement.addClass('ccpa-critical-error');
				msgElement.addClass('error');
			} else {
				msgElement.removeClass('ccpa-critical-error');
				msgElement.removeClass('error');
			}

			COSTCO.util.showHtmlElementByFlag(msgElement, isShow);
		},

		/** creates an error notification for invalid state, then scrolls to it and focuses on the state field */
		displayInvalidStateNotification: function(form) {
			let containerDiv = $('#errorMessageContainerDiv');
			let msgElement = $('#errorMessageDiv');
			var error = '<span class="offscreen">Error: </span>';
			let savedUserVerification = $('#savedUserVerification').val();
			let userType = $('#userType').val();

			msgElement.empty().append(error + messages.CCPA_STATES_VALIDATION_MSG);
			DSRHelper.showHideErrorMessage(true);
			COSTCO.util.showHtmlElementByFlag(containerDiv, true);

			if(userType == undefined) {
				if(savedUserVerification === "pageName:Data Rights Request | Validated User Verification;pageType:Data Rights Request") {
					window.digitalDataEvents = [];
					digitalDataEvents.push( { uimsg:"Data Rights Request | Validated User Verification | Currently Not Processing" } );
				} else {
					window.digitalDataEvents = [];
					digitalDataEvents.push( { uimsg:"Data Rights Request | Non-Validated User Verification | Currently Not Processing" } );
				} 
			} else {
				window.digitalDataEvents = [];
				digitalDataEvents.push( { uimsg:"Data Rights Request | Currently Not Processing" } );
			
			}
			// focus on state field
			let stateElement = form.find('#state');
			COSTCO.util.ariaSetElementAsInvalid(stateElement, 'errorMessageContainerDiv');
			DSRHelper.handleShowTopNotification(stateElement);
		},

		/** Method to validate location eligibility for DSR */
		checkLocationEligibility: function(form) {
			var eligible = false;
			var eligibleStates = form.find('#eligibleStatesList').val();
			var selectedState = form.find('#state option:selected').val();
			let eligibleStatesArray = [];

			
			if(selectedState === "NO_STATE_TYPE_SELECTED") {
				window.digitalDataEvents = [];
				digitalDataEvents.push({ uimsg: "Data Rights Request | State is required" });
			}
			
			if (~eligibleStates.indexOf('|')) {
				eligibleStatesArray = eligibleStates.split('|');
			} else {
				eligibleStatesArray[0] = eligibleStates;
			}

			if (eligibleStatesArray.indexOf(selectedState) > -1) {
				eligible = true;
			}

			return eligible;
		},

		/** Method for redirecting user to Login/DSRView */
		hasOnlineAccount: function() {
			DSRHelper.validationRulesDSRForLanding();
			let userType = $('#userType').val();
			let userChoiceBehalf = $('input[name=isBehalfSelect]:checked').val();
			let userChoiceHasAccount = $('input[name=ccpaHasAccount]:checked').val();
			let redirectUrl ='';
			let hashedUserId = $.cookie('hashedUserId');

			// remove error notification in case it's in place then run check again
			let form = $('#DSRLanding');
			COSTCO.util.showHtmlElementByFlag(form.find('#errorMessageContainerDiv'), false);
			DSRHelper.showHideErrorMessage(false);

			let stateElement = form.find('#state');
			COSTCO.util.ariaSetElementAsValid(stateElement);

			let isStateEligible = DSRHelper.checkLocationEligibility(form);
			let isFormValid = form.valid();

			if (isStateEligible && isFormValid && (typeof userType !== undefined)) {
				if (userChoiceBehalf === 'BEHALF_YES') {
					let dsrUrl = $('#dsrURL').val();
					dsrUrl = dsrUrl+'&loginType='+'C';
					redirectUrl = dsrUrl;
				} else {
					if (userChoiceHasAccount === 'ACCOUNT_YES') {
						let logonURL = $('#logonURL').val();
						redirectUrl = logonURL;
						if(userType === 'R' || (hashedUserId && hashedUserId != '""' && hashedUserId != '')) {
							let LogoffURL = $('#logoffURL').val();
							redirectUrl = LogoffURL;
						}
					} else if (userChoiceHasAccount === 'ACCOUNT_NO') {
						if (userType === 'R'|| (hashedUserId && hashedUserId != '""' && hashedUserId != '')) {
							let dsrUrl = $('#dsrURL').val();
							dsrUrl = dsrUrl+'&useAccount=false';
							redirectUrl = dsrUrl;
						} else {
							let dsrUrl = $('#dsrURL').val();
							dsrUrl = dsrUrl+'&loginType='+'B';
							redirectUrl = dsrUrl;
						}
					}
				}
				
				window.location.href = redirectUrl;
			} else if (DSRHelper.getIsStateSelected() && !isStateEligible) {
				DSRHelper.displayInvalidStateNotification(form);
			}
		},

		/** Method to validate DSRForm */
		dsrFormValid: function() {
			DSRHelper.validate();

			// remove error notification in case it's in place then run check again
			let form = $('#DSRForm');
			COSTCO.util.showHtmlElementByFlag(form.find('#errorMessageContainerDiv'), false);
			DSRHelper.showHideErrorMessage(false);

			let stateElement = form.find('#state');
			COSTCO.util.ariaSetElementAsValid(stateElement);
			
			let isStatEligible = DSRHelper.checkLocationEligibility(form);
			let isFormValid = form.valid();
			
			if (isFormValid && isStatEligible) {
				return true;
			} else if (DSRHelper.getIsStateSelected() && !isStatEligible) {
				DSRHelper.displayInvalidStateNotification(form);

				// reset focus on first error field on screen
				if (!isFormValid) {
					let firstInvalidInput = $(':input[aria-invalid=true]:first');
					DSRHelper.focusAndScrollToElement(null, firstInvalidInput, firstInvalidInput);
				}
			}
		},
		
		submitOBOForm: function(value) {
			if (!$('input[name=isCheckBoxSelected]').prop('checked')) {
				$('.ccpa-consumer-rights-main').find('.ccpa-request-check-box').addClass('ccpa-critical-error');
				$('.ccpa-consumer-rights-main').find('.ccpa-request-check-box-content').addClass('ccpa-request-check-box-content-error');

				window.digitalDataEvents = [];
				digitalDataEvents.push( { uimsg:"Data Rights Request | OBO Declaration Page | Select the checkbox to continue" } );
				
				let errorDiv = $('#checkbox-error-msg-div');
				errorDiv.removeClass('hidden');
				
				let checkBox = $('#c1');
				COSTCO.util.ariaSetElementAsInvalid(checkBox, 'checkbox-error-msg-div');
				DSRHelper.focusAndScrollToElement(checkBox, checkBox, checkBox);
			} else {
				window.location.href = value;
			}
		},

		/** used on onblur event of all fields so that the screen reader 
		 * would announce the error when focus moves out of the field */
		alertScreenReader: function(element) {
			if ($(element).attr('aria-invalid') === 'true') {
				let elementName = $(element).attr('name');
				let errorElement = $('#' + elementName + 'Error');

				errorElement.removeAttr('role');
				errorElement.attr('role', 'alert');
			}
		},

		showErrorLabel: function(errorElement, sourceElement) {
			let sourceElementName = $(sourceElement).attr('name');
			$(errorElement).attr('aria-live', 'polite');
			$(errorElement).attr('id', sourceElementName + 'Error');
			$(errorElement).addClass('dynamic-error');

			let errorSpan = '<span class="offscreen">'+ messages.OFFSCREEN_ERROR + ' </span>';
			$(errorElement).prepend(errorSpan);
			
			if (sourceElement.is(':radio')) {
				$(errorElement).appendTo( sourceElement.parents('.radio-fieldset') );
				
			} else {
				errorElement.insertAfter(sourceElement);
			}
		},		

		formValidatorHighlight: function(element, errorClass, validClass) {
			let elementName = $(element).attr('name');
			let elements = $('[name=' + elementName + ']');
			COSTCO.util.ariaSetElementAsInvalid(elements, elementName + 'Error');
			elements.addClass(errorClass).removeClass(validClass);
		},

		formValidatorUnhighlight: function(element, errorClass, validClass) {
			let elementName = $(element).attr('name');
			let elements = $('[name=' + elementName + ']');

			if (elementName !== 'state' || 
					(elementName === 'state' && $('#errorMessageContainerDiv').hasClass('hide'))) {
				COSTCO.util.ariaSetElementAsValid(elements);
			}
			elements.removeClass(errorClass).addClass(validClass);
		},
		
		validationRulesDSRForLanding: function() {
			DSRHelper.dsrLandingValidationRules();
			let form = $('#DSRLanding');

			form.validate({
				rules: {
					state : {checkStateEmpty: true},
					isBehalfSelect: {checkIsBehalfEmpty: true},
					ccpaHasAccount: {checkIsHasAccountEmpty: true}
				},
				messages :{
					state : messages.ERR_LANDING_INVALID_STATE,
					isBehalfSelect: messages.ERR_SELECT_AN_OPTION,
					ccpaHasAccount: messages.ERR_SELECT_AN_OPTION
				},
				ignore: [],
				errorElement: 'div',
				errorPlacement: function(error, element) {
					DSRHelper.showErrorLabel(error, element);
				},
				onfocusout: function(element) {
					// save and reuse the aria-invalid attribute so it won't get overrun
					let ariaInvalidAttr = $(element).attr('aria-invalid');

					this.element(element); 
					
					$(element).attr('aria-invalid', ariaInvalidAttr);
				}, 
				highlight: DSRHelper.formValidatorHighlight,
				unhighlight: DSRHelper.formValidatorUnhighlight,
				invalidHandler: COSTCO.util.invalid_handler
			});
		},

		/** Method to validate DSRForm */
		validate: function() {
			DSRHelper.validationRules();
			let form = $('#DSRForm');
		 	let userChoice = form.find('[name=userChoice]').val() != 'A' ?true:false;
			let isRequired = (userChoice == true)?true:$('.ccpa-consumer-page').find('.ccpa-confirmation-email').hasClass('ccpa-confirmation-email-space');

			form.validate({
				rules: {
					fName : {required: true},
					lName : {required: true},
					streetAddress: {required: true,maxlength:45},
					email :{required: true ,emails: true, maxlength:254},
					confirmEmail: {required: isRequired, emails: isRequired, maxlength: 254, confirmEmails: isRequired},
					postal:{required: true,countryspecificpostalcodePassCountrySelectorModal:true},
					city : {required:true},
					state : {checkStateEmpty: true},
					birthYearCCPA:{required:true,birthYearValidations:true}
				},
				messages :{
					fName : {required:messages.ERR_INVALID_FIRSTNAME},
					lName : {required:messages.ERR_INVALID_LASTNAME},
					streetAddress : {required: messages.ERR_INVALID_STREETADDRESS, maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH_FRIENDLY_MESSAGE},
					postal : messages.ERR_ENTER_ZIPCODE,
					email : {required:messages.ERR_REQUIRED_EMAIL_MY, emails:messages.ERR_INVALID_EMAIL, maxlength: messages.ERR_INVALID_EMAIL},
					confirmEmail : {required:messages.ERR_CCPA_REQUIRED_CONFIRM_EMAIL, emails:messages.ERR_INVALID_EMAIL, maxlength: messages.ERR_INVALID_EMAIL,confirmEmails: messages.ERR_CONFIRM_EMAIL_MISMATCH},
					city : messages.ERR_INVALID_CITY,
					state : messages.ERR_INVALID_STATE,
					birthYearCCPA:{required:messages.ERR_REQUIRED_BIRTH_YEAR,birthYearValidations:messages.ERR_INVALID_BIRTH_YEAR}
					
				},
				errorElement: 'div',
				errorPlacement: function(error, element) {
					if(element.attr('id') === 'birthYearCCPA'){
						COSTCO.util.showHtmlElementByFlag($('.ccpa-consumer-page').find('.ccpa-year-birth-desc'), false);
						
						 if(form.find('[name=birthYearCCPA]').val() === '') {
							$(element).attr('placeholder','YYYY');
							$('label[for="' + $(element).attr('id') + '"]').addClass( "active" );
						 }
					}
					
					DSRHelper.showErrorLabel(error, element);
				},
				onfocusout: function(element) {
					// save and reuse the aria-invalid attribute so it won't get overrun
					let ariaInvalidAttr = $(element).attr('aria-invalid');

					this.element(element); 
					
					$(element).attr('aria-invalid', ariaInvalidAttr);
				},
				success: function(element) {
				    if(element.prev().attr('id') === 'birthYearCCPA'){
						COSTCO.util.showHtmlElementByFlag($('.ccpa-consumer-page').find('.ccpa-year-birth-desc'), true);
					}
				},
				highlight: DSRHelper.formValidatorHighlight,
				unhighlight: DSRHelper.formValidatorUnhighlight,
				invalidHandler: COSTCO.util.invalid_handler
			});
		},
		
		dsrLandingValidationRules: function() {
			$.validator.addMethod('checkStateEmpty', function( value, element ) {
				return DSRHelper.getIsStateSelected();
			});

			$.validator.addMethod('checkIsBehalfEmpty', function( value, element ) {
				if ($('input[name=isBehalfSelect]:checked').val() === undefined) {
					window.digitalDataEvents = [];
					digitalDataEvents.push( { uimsg:"Data Rights Request | ForSelf | Select an option above" } );
					return false;
				}
				return true;
			});

			$.validator.addMethod('checkIsHasAccountEmpty', function( value, element ) {
				if ($("#isBehalfNoInput").is(':checked') && ($('input[name=ccpaHasAccount]:checked').val() === undefined)) {
					window.digitalDataEvents = [];
					digitalDataEvents.push( { uimsg:"Data Rights Request | Account | Select an option above" } );
					return false;
				}

				return true;
			});
		},
		
		/** Method defines DSRForm validation criteria */
		validationRules: function() {
			$.validator.addMethod("emails", function( value, element ) {
				return /^[a-zA-Z0-9\-_+]+([.][a-zA-Z0-9\-_+]+)*@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-_]+\.)+))([a-zA-Z]{2,10})$/.test(value.toLowerCase());
			});

			$.validator.addMethod("countryspecificpostalcodePassCountrySelectorModal", function( value, element) {
				return !COSTCO.CAddressForm.isUS({input: element})
						? this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_CA.test($.trim(value))
						: this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_US.test($.trim(value))
			});

			$.validator.addMethod("confirmEmails", function( value, element ) {
			    var email=$('#DSRForm').find('[name=email]').val().trim().toLowerCase();
				return value.toLowerCase()==email;
			});

			$.validator.addMethod('checkStateEmpty', function( value, element ) {
				return DSRHelper.getIsStateSelected();
			});

			$.validator.addMethod("birthYearValidations", function( value, element ) {
			  let validYear = true;
			  if(value.length<4){
				validYear = false;
			  }
	          let enteredYear = value;
	          let now = new Date();
	          let currentYear = parseInt(now.getFullYear().toString());
	          let beginningYear = currentYear - 130;
	          if (enteredYear >= currentYear || enteredYear < beginningYear) {
	        	  validYear = false;
	          }
			  return validYear;
			});
		},
		
		/** Method to focus the selected idology answer */
		selectOption: function(id) {
			$('input:radio[name="idologyAnswer"]:checked').attr('checked', false);
			$(id).attr('checked', 'checked');
		},
		
		/** Method to call validation method of recaptcha */
		validateReCaptcha: function(grecaptcha){
			if(DSRHelper.dsrFormValid()){
				grecaptcha.reset();
				grecaptcha.execute();
			}			
		},

		/** Hides the "Learn More" link after it's clicked and resets the focus */
		showRecaptchaDetails: function() {
			$('#DSRForm').find('#ccpa-recaptcha-learn-more-link').addClass('hide');
			$('#DSRForm').find('#recaptcha-message-top').focus();
		},
		
		/** DSRFrom submission and Idology service calling method */
		aunthenticateDSRRequest: function() {
			let fromPage = 'DSRForm';				
			let isOBOFlow = $('#DSRForm').find('[name=ccpaType]').val();
			let enableEmailValidation = $('#DSRForm').find('[name=enableEmailValidation]').val();
			let hasNoUserAccount = $('#DSRForm').find('[name=userChoice]').val() === 'B';
			let isNonMember = $('#DSRForm').find('[name=isNonMember]').val();
			$('#DSRForm').addClass('ajax-busy');
			if (isOBOFlow === 'true') {
			   this.redirectToPortal();
			} else {
				if (enableEmailValidation === 'true') {
					if (hasNoUserAccount || (!hasNoUserAccount && isNonMember)) {
						// call the email verification api to send an otp - when successful open modal
						this.sendNewEmailVerificationCode();
					}
				}
				else {
					this.showIdologyQuestionnaire(fromPage);
				}
			}
		},
		
		/**
		 * When user edits the form after email verification, the form will be validated and idology validation will be continued
		 */
		continueValidationOnEditedForm : function() {
			if(DSRHelper.dsrFormValid()){
				DSRHelper.showIdologyQuestionnaire('DSRForm');
			}
		},
		
		/**
	     * Opens idology verification dialog
	     * @param  {number} membershipNum Membership number
	     */
		showIdologyQuestionnaire : function(fromPage) {
			let answerNumber = $('input[name=idologyAnswer]:checked').val();
			let memberId = $('#memberId').val();
			let questionSet=$('#questionSet').val();
			let isVerified=$('#isVerified').val();
			let fName=$('#fName').val();
			let lName=$('#lName').val();
			let email=$('#email').val();
			let addressL1=$('#addressL1').val();
			let addressL2=$('#addressL2').val();
			let city=$('#city').val();
			let state=$('#state').val();
			let zip=$('#zip').val();
		    let nonMember=$('#nonMember').val();
		    let ccpaEligibleStates=$('#ccpaEligibleStates').val();
		    let postal=$('#postal').val();
		    let streetAddress=$('#streetAddress').val();
			let birthYearCCPA=$('#birthYearCCPA').val();
			
			if (fromPage === 'DSRForm') {
				$('#idologyAnswerError').hide();
			} else if (answerNumber === undefined || answerNumber === null) {
				$('#idologyErrorLabel').attr('for', 'questionFieldset');
				COSTCO.util.ariaSetElementAsInvalid($(':input[type="radio"]'), 'idologyAnswerError');
				
				let firstRadioButton = $(':input[type="radio"]:first');
				let idologyErrorDiv = $('#idologyAnswerError');
				idologyErrorDiv.show();
				DSRHelper.focusAndScrollToElement(idologyErrorDiv, firstRadioButton, firstRadioButton);

				return;
			}
			
			let url;
			if(null != answerNumber && answerNumber != undefined) {
				url = this.makeVerificationUrl({
					answerNumber:answerNumber,
					memberId:memberId,
					questionSet:questionSet,
					isVerified:isVerified,
					fName:fName,
				    lName:lName,
					email:email,
					addressL1:addressL1,
					addressL2:addressL2,
					city:city,
				    state:state,
					zip:zip,
					nonMember:nonMember,
					ccpaEligibleStates:ccpaEligibleStates,
					postal:postal,
					streetAddress:streetAddress,
					birthYearCCPA:birthYearCCPA
				});
			} else {
				url = this.makeVerificationUrl($('#DSRForm').serializeArray());
			}
            this.submitRequest(url)
        	.then((data) => {
        	   	$('#questionSet').val(data.questionSet);
        	
        		if (data.CRM_AUTH_QUESTION && data.CRM_AUTH_QUESTION.answers && data.CRM_AUTH_QUESTION.answers.length > 0) {
        			this.showQuestionsStep(data);
        		} else if ('CRM_AUTH_PASSED' in data || !data.DSRFORM_MODIFIED) {
        			if ('CRM_AUTH_PASSED' in data) {
        				$('#verifiedIdentity').val(data.CRM_AUTH_PASSED);
        			}
        			$('#idologyView').addClass('ajax-busy');
        			this.redirectToPortal();
        		}
        	});
		},
		      
		/** User verification controller command calling method */
		makeVerificationUrl: function(params) {
			return COSTCO.util.makeUrl('/AjaxCostcoVerifyDSRRequestedUserCmd', params);
		},
			
		/** Ajax form submission method */
		submitRequest: function(urlWithParams) {
			return COSTCO.util.ajax({
				type: 'POST',
				url: urlWithParams,
				dataType: 'json',
			})
	        .then((data) => {
	          	return $.Deferred().resolve(data);
	        })
	        .fail((errorMsg, errorData) => {
    			$('#verifiedIdentity').val(false);
	        	this.redirectToPortal();
	        });
	    },
		    
	    /** Method to display Idology content using html/template */
	    showQuestionsStep: function(data) {
	    	$('#dsrView').hide();
	    	$('#idologyView').show();
	    	$('html, body').animate({
	    		scrollTop: $('#idologyView').offset().top
	    	}, 'fast');
            if (data.CRM_AUTH_QUESTION && data.CRM_AUTH_QUESTION.answers && data.CRM_AUTH_QUESTION.answers.length > 0) {
        		if (data.CRM_AUTH_QUESTION) {
        			let idologyQuestionTmpl = $(COSTCO.util.tmpl('tmpl_idology_questions', {
        				verificationQuestion: data.CRM_AUTH_QUESTION.question,
    	        	}));
        			$('#idologyQuestionContent').html(idologyQuestionTmpl);
        			
        			let idologyAnswerTmpl = '';
	        		$.each(data.CRM_AUTH_QUESTION.answers, (index, value) => {
	        			idologyAnswerTmpl = idologyAnswerTmpl + COSTCO.util.tmpl('tmpl_idology_answers', {
	    					answerId: index,
	    					verificationAnswer: value,
	        			});
	    			})
					$('#idologyAnswerContent').html(idologyAnswerTmpl);
					$(':input[type="radio"]:first').focus();
        		}
            }
    	},
		
    	/**
    	 * Call Email Verification command to verify the code entered 
    	 */  
		sendNewEmailVerificationCode: () => {
			let formdata = {'action': 'sendOtpCode'};
			formdata['email'] = $('#email').val();
			return COSTCO.util.ajax({
				type: 'POST',
				url: '/EmailVerificationCmd',
				data: formdata,
				dataType: 'json',
			})
	        .then((data) => {
	        	if(data && data.response === "success") {
	        		if($('#costcoModal').css('display') == 'none') {
        				DSRHelper.openOTPVerificationCodeModal();
					} 
					else {
		        		$('#modalErrorContainer').html('');
		        		$('#verificationCode').val('');
			        	$('#verificationCode').removeAttr('aria-invalid');
			        	$('#verificationCode').removeClass('error');
					}
				}
	        	else if(data && data.response === "failure") {
	        		// show error on DSR form
	        		let containerDiv = $('#errorMessageContainerDiv')
	        		let error = '<span class="offscreen">Error: </span>';
	        		$('#errorMessageDiv').empty().append(error + messages.EMAIL_VERIFICATION_SENDING_OTP_FAILURE);
	    			DSRHelper.showHideErrorMessage(true);
	    			COSTCO.util.showHtmlElementByFlag(containerDiv , true);
	        	}
	        });
		},
    	
    	/**
    	 * Call Email Verification command to verify the code entered 
    	 */  
		verifyEmailVerificationCode: () => {
			let email = $('#DSRForm').serializeArray().find(x => x.name==="email").value;
			let code = $('#OTPVerificationForm').serializeArray()[0].value;
			let formdata = {'action': 'verifyOtpCode'};
			formdata['email'] = email;
			formdata['code'] = code;
			return COSTCO.util.ajax({
				type: 'POST',
				url: '/EmailVerificationCmd',
				data: formdata,
				dataType: 'json',
			})
			.then((data) => {
				if(data && data.response.status === "success") {
					COSTCO.dialog.close();
					$('#DSRForm').find('[name=isEmailOtpValid]').val(true);
					let DsrForm = $('#DSRForm');
					DsrForm.attr('action', 'CostcoDSRRequestCmd');
					DsrForm.submit();
					window.digitalDataEvents = window.digitalDataEvents || [];
					digitalDataEvents.push( {uimsg:"Data Rights Request | Email Address Verified"} );
				}
				else if(data && data.response.status === "failure") {
	        		// show error on OTP form
					if(data.response.message === "invalidOtpCode") {
		    			$('#verificationCode').val('');
			        	$('#modalErrorContainer').html(messages.DATA_RIGHTS_REQUEST_OTP_VERIFICATION_CODE_MODAL_INCORRECT_CODE);
			        	$('#verificationCode').focus();
			        	$('#verificationCode').attr('aria-invalid', 'true');
			        	$('#verificationCode').addClass('error');
					}
					else {
						$('#verificationCode').val('');
		        		let containerDiv = $('#errorMessageContainerDiv');
		    			COSTCO.util.showHtmlElementByFlag(containerDiv , true);
					}
				}
			});
		},
    	
        /**
         * Creates Verification Code Modal
         */
		openOTPVerificationCodeModal: function() {
			let settings = {
					title: messages.DATA_RIGHTS_REQUEST_OTP_VERIFICATION_CODE_MODAL_TITLE,
					body: COSTCO.util.tmpl('tmpl_dataRightsRequest_verification_code', {}),
					preventClose: true,
					primary: messages.DATA_RIGHTS_REQUEST_OTP_VERIFICATION_CODE_MODAL_VERIFY_CODE_BUTTON_TEXT,
					secondary: messages.DATA_RIGHTS_REQUEST_OTP_VERIFICATION_CODE_MODAL_SEND_NEW_CODE_BUTTON_TEXT,
					setHalfButtons: true,
					primary_event: () => {
						DSRHelper.verifyEmailVerificationCode();
					},
					secondary_event: () => {
						DSRHelper.sendNewEmailVerificationCode();
					},
					close: () => {
						COSTCO.dialog.close();
						$('#dsrContinueBtn').focus()
						$('#DSRForm').removeClass('ajax-busy');
					},
			};
			COSTCO.dialog.createExtDialogBox(settings);
			// close modal when esc key is pressed
			$('#costcoModal').bind('keydown', function(e) {
		        if (e.which == 27) {
		            settings.close();
		        }
		    });
			// allow user to enter only 6 digits
			$('#verificationCode').bind('keypress', function(e) {
				var reg = new RegExp('^[0-9]+$');
				return reg.test(e.key) && e.target.value.length!=6;
		    });
			$('#verificationCode').on('input', function(e) {
	        	$('#modalErrorContainer').html('');
	        	$('#verificationCode').removeAttr('aria-invalid');
	        	$('#verificationCode').removeClass('error');
		    });
			// allow user to paste only 6 digits
			$('#verificationCode').bind('paste', function() {
	        	$('#modalErrorContainer').html('');
	        	$('#verificationCode').removeAttr('aria-invalid');
	        	$('#verificationCode').removeClass('error');
	        	let pasteValue = (event.clipboardData || window.clipboardData || event.originalEvent.clipboardData).getData('Text');
				let reg = new RegExp('^[0-9]+$');
				return reg.test(pasteValue) && (this.value.length + pasteValue.length) == 6;
		    });
		},
    	
    	/** Redirection to customer portal by calling the controller command 
    	 * CostcoAuthenticateDSRRequestCmd
    	 */
    	redirectToPortal: function() {
    		$('#DSRForm').attr('action', 'CostcoAuthenticateDSRRequestCmd');
			$('#DSRForm').submit();
    	},
    	
    	/** Redirection to Costco home page */
    	goToHomePage: function() {
    		window.location = "/";
    	},
    	
    	selectAnswer: function() {
			$('#idologyAnswerError').hide();
			$('#idologyErrorLabel').removeAttr('for');
			COSTCO.util.ariaSetElementAsValid($(':input[type="radio"]'));
    	}
	};
	  
	if (typeof window.COSTCO === 'undefined') {
		window.COSTCO = {};
	}
	$(document).ready(function() {
		if(COSTCO && COSTCO.Global && COSTCO.DSRHelper){
			COSTCO.Global.notify('DSRHelperLoaded');
		}
		DSRHelper.init();
		
	});
	window.COSTCO.DSRHelper = DSRHelper;
	return DSRHelper;
});


// WEBPACK FOOTER //
// ./js/ccpa/dsr-helper.js